import { Redirect, Route, Switch } from 'react-router';

import routes from '../../app/routes';
import BaseLoggedPage from '../../templates/BaseLoggedPage';
import AdminAccountManagement from './accountManagement/AdminAccountManagement';
import AdminConsoleTitle from './components/AdminConsoleTitle';
import { useAdminConsolePageStyles } from './AdminConsolePage.styles';
import AdminConsoleTabs from './layout/AdminConsoleTabs';

export default function AdminConsolePage() {
  const { styles } = useAdminConsolePageStyles();

  return (
    <BaseLoggedPage innerContentClassName={styles.innerContent}>
      <div className={styles.heading}>
        <AdminConsoleTitle titleId="admin.console.title" />
      </div>
      <AdminConsoleTabs />
      <div className="AdminConsolePage__Body">
        <Switch>
          <Route
            path={[
              routes.admin.accountDetail.root,
              routes.admin.accountManagement,
            ]}
          >
            <AdminAccountManagement />
          </Route>
          <Route path={routes.admin.userManagement}>
            <span>USER MANAGEMENT</span>
          </Route>
          <Route path={routes.admin.prefix} exact>
            <Redirect to={routes.admin.accountManagement} />
          </Route>
        </Switch>
      </div>
    </BaseLoggedPage>
  );
}
